import config from '@/config'
import HttpClient from '@/api/http/client'

const http = new HttpClient(config.viacepBaseUrl)

export default {
  async searchZipcode(zipcode) {
    const result = await http.get(`/ws/${zipcode}/json`)

    if (!result.ok) {
      return null
    }

    const response = await result.json()
    return {
      address: response.logradouro,
      state: response.uf,
      city: response.localidade,
      district: response.bairro
    }
  }
}
